import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import plusIcon from "../../../../../Assets/icons/plus-circle.svg";
import MinusIcon from "../../../../../Assets/icons/Minus-circle.svg";
import axiosInstance from "../../../../services/api/API";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import { Modal, Offcanvas } from "react-bootstrap";
import moment from "moment";
import AddIssueDynemicForm from "../../addIssueDynemicFrom";
import Swal from 'sweetalert2';

const estimateTime = [
  {
    label: "1:00:00",
    value: "01:00:00",
  },
  {
    label: "2:00:00",
    value: "02:00:00",
  },
  {
    label: "3:00:00",
    value: "03:00:00",
  },
  {
    label: "4:00:00",
    value: "04:00:00",
  },
  {
    label: "5:00:00",
    value: "05:00:00",
  },
  {
    label: "6:00:00",
    value: "06:00:00",
  },
  {
    label: "7:00:00",
    value: "07:00:00",
  },
  {
    label: "8:00:00",
    value: "08:00:00",
  },
  {
    label: "9:00:00",
    value: "09:00:00",
  },
  {
    label: "10:00:00",
    value: "10:00:00",
  },
];

const TechnicianDetails = () => {
  const location = useLocation();
  const { data } = location?.state || {};
  const navigate = useNavigate();
  const [jobCardDetails, setJobCardDetails] = useState([]);
  const [jobCardIssueList, setJobCardIssueList] = useState([]);
  const [modalType, setModalType] = useState(null);
  const token = localStorage.getItem("authToken");
  const [addPart, setAddPart] = useState(false);
  const [formData, setFormData] = useState({ issue_status: 0 });
  const [validationErrors, setValidationErrors] = useState({});
  const [partType, setPartType] = useState([]);
  const [partlistData, setPartListData] = useState([]);
  const [addModel, setAddModel] = useState(false);
  const [complainList, setComplainList] = useState([]);
  const [technicianList, setTechnicianList] = useState([]);
  const [repair, setRepair] = useState([]);
  const [editIssueData, setEditIssueData] = useState();
  const bussness_id = data?.business_partner_id;
  const job_Card_id = data?.job_card_id;

  const businessPartnerId = localStorage.getItem("business_partner_id")
  console.log(businessPartnerId, "businesspartnerid")

  const [issueId, setIssueId] = useState(0);

  const IssueInputs = [
    {
      name: "Complain",
      label: "Complain",
      type: "dropdown",
      required: true,
      // options: options,
      options: complainList,
      gridClass: "col-lg-12 mb-3",
      validation: { required: true },
    },
    {
      name: "Complain_Description",
      label: "Complain Description",
      placeholder: "Enter Complain Description",
      type: "text",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: {
        required: true,
        maxLength: 50,
        pattern: /^[A-Za-z0-9 ]*$/,
        message: "Only alphabets and digits are allowed",
      },
    },
    {
      name: "estimated_cost",
      label: "Estimate Cost",
      placeholder: "Enter Estimate Cost",
      type: "number",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: { required: true },
    },
    {
      name: "technician",
      label: "Technician",
      type: "dropdown",
      required: true,
      // options: options,
      options: technicianList || [],
      gridClass: "col-lg-12 mb-3",
      validation: { required: true },
    },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      placeholder: "Enter Remark",
      required: true,
      gridClass: "col-lg-12 mb-3",
      disabled: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9 ]*$/,
        message: "Only alphabets and digits are allowed",
        maxLength: 50,
      },
    },
    {
      name: "tech_remark",
      label: "Tech Remark",
      type: "text",
      placeholder: "Enter Tech Remark",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9 ]*$/,
        message: "Only alphabets and digits are allowed",
        maxLength: 50,
      },
    },
    {
      name: "issue_status",
      label: "Issue Status",
      type: "dropdown",
      options: [
        { label: "Pending", value: 0 },
        { label: "Done", value: 1 },
      ],
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: { required: true },
    },
    {
      name: "repair",
      label: "Repair",
      type: "dropdown",
      options: repair || [],
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: { required: true },
      dropdownOptionsListPosition: "top",
    },
    {
      name: "east_time",
      label: "Estimate Time",
      placeholder: "Enter Estimate Time",
      type: "text",
      gridClass: "col-lg-12",
      disabled: true,
    },
    {
      name: "actual_time",
      label: "Actual Time",
      placeholder: "Enter Actual time",
      type: "dropdown",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: { required: true },
      options: estimateTime || [],
    },
  ];

  const PartInputs = [
    {
      name: "technician_name",
      label: "Technician Name",
      type: "text",
      placeholder: "Enter Technician Name",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "issue",
      label: "Issue",
      type: "text",
      placeholder: "Enter Issue",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },

    {
      name: "repair_status",
      label: "Repair",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "part_type",
      label: "Part Type",
      type: "dropdown",
      options: partType || [],
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "item_name",
      label: "Item Name",
      type: "text",
      placeholder: "Enter Item name",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "goodQty",
      label: "Goods Qty",
      type: "text",
      placeholder: "Enter Goods Qty",
      required: true,
      gridClass: "col-lg-4",
      validation: { 
        required: true,
        pattern: /^[0-9]+$/,  // Only allows numbers (0-9)
        maxLength: 10,
        message: "Please enter a valid number",
      
      },
    },
  ];

  const handlePartFormSubmit = async (data) => {
    const errors = {};
    let isValid = true;

    PartInputs.forEach((field) => {
      console.log("field>>",field);
      if (field.required && !formData[field.name]) {

        errors[field.name] = "This field is required";
        isValid = false;
      } else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      console.log("validationErrors",validationErrors);
      return;
    }

    // setIsLoading(true);
    if (data?.part_detail_id) {
      try {
        const response = await axiosInstance.patch(
          "/partdetail/update/" + data?.part_detail_id,
          {
            business_partner_id: data?.bussness_id?data?.bussness_id:businessPartnerId==0?1:businessPartnerId,
            job_card_id: data?.job_Card_id,
            work_detail_id: null,
            issue_detail_id: data?.comp_id,
            item_name: data?.item_name,
            item_id: null,
            item_type_id: data?.part_type,
            good_qty: data?.goodQty,
            master_rate: null,
            discount_per: null,
            discount_amount: null,
            rate: null,
            gst_taxset: null,
            gst_taxset_amount: null,
            item_total_amount: null,
            is_super_viser_approve: null,
            is_part_allocated: null,
            super_viser_approve_datetime: null,
            part_allocated_dateTime: null,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setAddPart(false);
        fetchJobCardIssueList();
        fetchJobCardDetails();
        setIssueId("");
      } catch (error) {
        console.error("Error fetching business partners:", error);
      }
    } else {
      try {
        const response = await axiosInstance.post(
          "/partdetail/create",
          {
            business_partner_id: data?.bussness_id?data?.bussness_id:businessPartnerId==0?1:businessPartnerId,
            job_card_id: data?.job_Card_id,
            work_detail_id: null,
            issue_detail_id: data?.comp_id,
            item_name: data?.item_name,
            item_id: null,
            item_type_id: data?.part_type,
            good_qty: data?.goodQty,
            master_rate: null,
            discount_per: null,
            discount_amount: null,
            rate: null,
            gst_taxset: null,
            gst_taxset_amount: null,
            item_total_amount: null,
            is_super_viser_approve: null,
            is_part_allocated: null,
            super_viser_approve_datetime: null,
            part_allocated_dateTime: null,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setAddPart(false);
        fetchJobCardIssueList();
        fetchJobCardDetails();
        onClickSetIssueId("");
      } catch (error) {
        console.error("Error fetching business partners:", error);
      }
    }
  };


const handleFormSubmit = async (data) => {
  const errors = {};
  let isValid = true;

  // Validate inputs
  IssueInputs.forEach((field) => {
    if (field.validation && field.validation.required) {
      if (!formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      }
    }
  });

  if (!isValid) {
    setValidationErrors(errors);
    return;
  }

  // Confirmation alert before submission
  const confirmation = await Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to save this issue?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, save it!',
    cancelButtonText: 'Cancel',
  });

  if (!confirmation.isConfirmed) {
    return;
  }

  try {
    // Check if we are editing or creating a new issue
    const apiEndpoint = editIssueData?.comp_id
      ? "/jobcardcomplain/jobcardcomplainupdate"
      : "/jobcardcomplain/create";

    const payload = {
      business_partner_id:businessPartnerId==0?1:businessPartnerId ,
      job_card_id: editIssueData?.job_card_id || job_Card_id || null,
      comp_id: editIssueData?.comp_id || null,
      complain_id: data?.Complain || null,
      complain_desc: data?.Complain_Description || null,
      estcost: data?.estimated_cost || null,
      technician_id: data?.technician || null,
      remark: data?.remark || null,
      issue_status: data?.issue_status || 0,
      esttime: data?.east_time || null,
      tech_remark: data?.tech_remark || null,
      actual_time: data?.actual_time || null,
      repair_id: data?.repair || null,
      status: 1,
    };

    const response = await axiosInstance.post(apiEndpoint, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response?.status) {
      // Success alert
      Swal.fire({
        title: 'Success!',
        text: editIssueData?.comp_id
          ? 'Issue updated successfully.'
          : 'Issue created successfully.',
        icon: 'success',
        confirmButtonText: 'OK',
      }).then(() => {
        setAddModel(false);
        fetchJobCardIssueList();
        fetchJobCardDetails();
        setFormData({ issue_status: 0 });
      });
    }
  } catch (error) {
    // Error alert
    Swal.fire({
      title: 'Error!',
      text: 'There was an error processing your request. Please try again later.',
      icon: 'error',
      confirmButtonText: 'OK',
    });
    console.error("Error:", error);
  }
};


  // const handleFormSubmit = async (data) => {
  //   const errors = {};
  //   let isValid = true;
  //   IssueInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       }
  //     }
  //   });
  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }
  //   if (editIssueData?.comp_id) {
  //     try {
  //       const response = await axiosInstance.post(
  //         "/jobcardcomplain/jobcardcomplainupdate",
  //         {
  //           business_partner_id: businessPartnerId || null,
  //           job_card_id: editIssueData?.job_card_id || null,
  //           comp_id: editIssueData?.comp_id,
  //           complain_id: data?.Complain || null,
  //           complain_desc: data?.Complain_Description || null,
  //           estcost: data?.estimated_cost || null,
  //           technician_id: data?.technician || null,
  //           remark: data?.remark || null,
  //           issue_status: data?.issue_status,
  //           esttime: data?.east_time || null,
  //           tech_remark: data?.tech_remark,
  //           repair_id: data?.repair || null,
  //           actual_time: data?.actual_time || null,
  //           status: 1,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //       if (response?.status) {
  //         setAddModel(false);
  //         fetchJobCardIssueList();
  //         fetchJobCardDetails();
  //         setFormData({ issue_status: 0 });
  //       }
  //     } catch (error) {
  //       console.error("Error fetching business partners:", error);
  //     }
  //   } else {
  //     try {
  //       const response = await axiosInstance.post(
  //         "/jobcardcomplain/create",
  //         {
  //           business_partner_id: businessPartnerId || null,
  //           job_card_id: job_Card_id || null,
  //           complain_id: data?.Complain || null,
  //           complain_desc: data?.Complain_Description || null,
  //           estcost: data?.estimated_cost || null,
  //           technician_id: data?.technician || null,
  //           remark: data?.remark || null,
  //           issue_status: data?.issue_status,
  //           esttime: data?.east_time || null,
  //           tech_remark: data?.tech_remark,
  //           actual_time: data?.actual_time || null,
  //           repair_id: data?.repair || null,
  //           status: 1,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //       if (response?.status) {
  //         const AddIssueData = response?.data?.data?.responseData;
  //         setAddModel(false);
  //         fetchJobCardIssueList();
  //         fetchJobCardDetails();
  //       }
  //     } catch (error) {
  //       console.error("Error fetching business partners:", error);
  //     }
  //   }
  // };

  const editOpenData = (issueDetails) => {
    setEditIssueData(issueDetails);
    if (issueDetails?.comp_id) {
      setFormData({
        Complain: issueDetails?.complain_id,
        Complain_Description: issueDetails?.complain_desc,
        estimated_cost: issueDetails?.estcost,
        remark: issueDetails?.remark,
        issue_status: issueDetails?.issue_status,
        east_time: issueDetails?.esttime,
        repair: issueDetails?.repair_id,
        technician: issueDetails?.technician_id,
        actual_time: issueDetails?.actual_time,
        tech_remark: issueDetails?.tech_remark,
      });
    }
    setAddModel(true);
  };

  const onClickSetIssueId = (id, issueDetails) => {
    if (id == "") {
      setIssueId("");
    } else {
      setIssueId(id);
      partList(issueDetails);
    }
  };
  const partList = async (issueDetails) => {
    try {
      const response = await axiosInstance.post(
        "/partdetail/getpartdetailbyissue",
        {
          business_partner_id: issueDetails?.bussness_id
            ? issueDetails?.bussness_id
            : issueDetails?.business_partner_id,
          job_card_id: issueDetails?.job_card_id,
          issue_detail_id: issueDetails?.comp_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status) {
        const dataList = response?.data?.data?.data;
        setPartListData(dataList);
      }
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchJobCardIssueList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/jobcardview",
        {
          business_partner_id: data?.business_partner_id ?data?.business_partner_id: 1,
          job_card_id: data?.job_card_id,
          login_user_id: null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        ...item,
      }));
      setJobCardDetails(formattedData[0]);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchJobCardDetails = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getservicesdetails",
        {
          business_partner_id: data?.business_partner_id ?data?.business_partner_id: businessPartnerId==0?1:businessPartnerId,
          job_card_id: data?.job_card_id,
          login_user_id: null,
          Type: "TechinicanComplainView",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response.data.data.map((item, index) => ({
        ...item,
      }));
      setJobCardIssueList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const OnClickaddPart = async (data) => {
    setAddPart(true);
    const response = await axiosInstance.post(
      "/technician/technicianissuerepair",
      {
        business_partner_id: businessPartnerId==0?1:businessPartnerId,
        comp_id: data?.comp_id,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response?.status == 200) {
      setFormData({
        technician_name: response?.data?.data?.data[0]?.technician_name || "",
        issue: response?.data?.data?.data[0]?.complain || "",
        repair_status: response?.data?.data?.data[0]?.repair_name || "",
        bussness_id: response?.data?.data?.data[0]?.business_partner_id || businessPartnerId,
        complain_id: response?.data?.data?.data[0]?.complain_id || "",
        job_Card_id: response?.data?.data?.data[0]?.job_card_id || "",
        comp_id: data?.comp_id,
      });
    }
  };

  const itemTypeList = async () => {
    try {
      const response = await axiosInstance.post("/jobcard/itemtype", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setPartType(
        response.data.data?.data
          .filter((item) => item?.itemtype !== "Vehicle") // Filter out items of type 'Vehicle'
          .map((item) => ({
            label: item?.itemtype,
            value: item?.itemtype_id,
          }))
      );
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const handlePartEdit = async (data) => {
    try {
      const response = await axiosInstance.post(
        "/technician/getpartdetailbyid",
        {
          business_partner_id: data?.business_partner_id==0?1:data?.business_partner_id,
          part_detail_id: data?.part_detail_id,
          comp_id: issueId,
          job_card_id: data?.job_card_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status) {
        const partdata = response?.data?.data?.data;
        setAddPart(true);
        setFormData({
          part_detail_id: partdata[0]?.part_detail_id,
          item_name: partdata[0]?.item_name,
          goodQty: partdata[0]?.good_qty,
          part_type: partdata[0]?.item_type_id,
          technician_name: partdata[0].technician_name || "",
          issue: partdata[0]?.complain || "",
          repair_status: partdata[0].repair_name || "",
          bussness_id: partdata[0].business_partner_id || "",
          complain_id: partdata[0].complain_id || "",
          job_Card_id: partdata[0].job_card_id || "",
          comp_id: issueId,
        });
      }
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchComplainList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getcustomerdetails",
        {
          business_partner_id: businessPartnerId==0?1:businessPartnerId,
          FilterId: null,
          FilterString: null,
          Type: "Complain",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        label: item?.name,
        value: item?.id,
      }));
      setComplainList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchTecnicianList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getcustomerdetails",
        {
          business_partner_id: businessPartnerId==0?1:businessPartnerId,

          FilterId: null,
          FilterString: null,
          Type: "Technician",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        label: item?.name,
        value: item?.id,
      }));
      setTechnicianList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchRepairList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getcustomerdetails",
        {
          business_partner_id: businessPartnerId==0?1:businessPartnerId,
          FilterId: null,
          FilterString: null,
          Type: "Repair",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        label: item?.name,
        value: item?.id,
      }));
      setRepair(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  useEffect(() => {
    fetchComplainList();
    fetchTecnicianList();
    fetchRepairList();
  }, []);

  useEffect(() => {
    itemTypeList();
  }, []);

  useEffect(() => {
    if (data) {
      fetchJobCardIssueList();
      fetchJobCardDetails();
    }
  }, []);

  const handleClose = () => {
    setEditIssueData(null);
    setFormData({ issue_status: 0 });
    setAddModel(!addModel);
    setValidationErrors({});
  };
  const backNavigate = () => {
    navigate("/manage-services/technician-to-do");
  };


  return (
    <div className="container-fuiled bg-white">
      <div className="OnboardManagamentContainer  mt-2 ">
        <span className="backbtntitle">
          <img src={backicon} alt="back" style={{ marginRight: 5 }} onClick={()=>backNavigate()}/>{" "}
          Technician To Do Details
        </span>
      </div>
      <div className="container-fuiled row  ">
        <div className="col-md-5 vechalDetails">
          <h5 className="m-3">Vehicle Details</h5>
          <div className="m-3">
            <div className="vechal-Details-SubViewTecnician">
              <div className="details-item">
                <span className="details-label">Job Card No.</span>
                <span className="details-value">
                  {jobCardDetails?.job_card_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Job Card Date </span>
                <span className="details-value">
                  {" "}
                  {moment(jobCardDetails?.transaction_date).format(
                    "DD/MM/YYYY"
                  )}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Customer Name</span>
                <span className="details-value">
                  {jobCardDetails?.customer_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Mobile No.</span>
                <span className="details-value">
                  {jobCardDetails?.contact_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Reg. No.</span>
                <span className="details-value">
                  {jobCardDetails?.registration_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Chassis No.</span>
                <span className="details-value">
                  {jobCardDetails?.chassis_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Engine No.</span>
                <span className="details-value">
                  {jobCardDetails?.engineno || "-"}
                </span>
              </div>
              {/* <div className="details-item">
                <span className="details-label">Pin Code</span>
                <span className="details-value">
                  {jobCardDetails?.pincode || "-"}
                </span>
              </div> */}

              <div className="details-item">
                <span className="details-label">Product Name</span>
                <span className="details-value">
                  {jobCardDetails?.product_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Sub Product Name</span>
                <span className="details-value">
                  {jobCardDetails?.subproduct_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Make</span>
                <span className="details-value">
                  {jobCardDetails?.make_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Model</span>
                <span className="details-value">
                  {jobCardDetails?.model_name || "-"}{" "}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Variant</span>
                <span className="details-value">
                  {jobCardDetails?.variant_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Variant Color</span>
                <span className="details-value">
                  {jobCardDetails?.color_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Fuel Type</span>
                <span className="details-value">
                  {jobCardDetails?.fuel_type_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Warranty Start Date</span>
                <span className="details-value">
                  {moment(jobCardDetails?.warranty_startdate).format(
                    "DD/MM/YYYY"
                  ) || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Warranty End Date</span>
                <span className="details-value">
                  {moment(jobCardDetails?.warranty_enddate).format(
                    "DD/MM/YYYYs"
                  ) || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Warranty Period</span>
                <span className="details-value">
                  {jobCardDetails?.warranty_period || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Supervisor</span>
                <span className="details-value">
                  {jobCardDetails?.supervisor_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Allocation Date</span>
                <span className="details-value">24/4/2024</span>
              </div>
              <div className="details-item">
                <span className="details-label">Job Estimate Amt.</span>
                <span className="details-value">
                  {jobCardDetails?.job_estimate_amount || 0}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Job Status</span>
                <span className="details-value">
                  {jobCardDetails?.status == 0 ? "Pending" : "Done"}
                </span>
              </div>
              {/* <div className="details-item">
                <span className="details-label">Complain</span>
                <span className="details-value">
                  {jobCardDetails?.complaint || '-'}
                </span>
              </div> */}
              <div className="details-item">
                <span className="details-label">Signature</span>
                <div style={{ display: "flex", gap: 5 }}>
                  <img
                    src={jobCardDetails?.signature_path}
                    style={{ height: 30, width: 50 }}
                  />
                  <span className="details-value">Verify</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-7">
          <div className="addButtonStyle m-2">
            <h5>Issue Details</h5>
           { jobCardDetails?.isgate_pass_done ===0 &&(
           <button
              className="addcustomerbutton"
              onClick={() => setAddModel(true)}
            >
              Add Issue
            </button>)}
          </div>
          <div className="m-3 bg-#eff0fe  ">
            {(jobCardIssueList || [])?.map((issueDetails) => (
              <div className="mb-3">
                <div className="issue-Details-SubViewTechnician">
                  <div className="details-item">
                    <span className="details-label">Complain</span>
                    <span className="details-value">
                      {issueDetails?.complain || "-"}
                    </span>
                  </div>
                  <div className="details-item">
                    <span className="details-label">Technician Name</span>
                    <span className="details-value">
                      {issueDetails?.technician_name || "-"}
                    </span>
                  </div>

                  <div className="details-item">
                    <span className="details-label">Complain Description</span>
                    <span className="details-value">
                      {issueDetails?.complain_desc || "-"}
                    </span>
                  </div>

                  <div className="d-flex gap-5 p-2 ">
                    <>
                    { jobCardDetails?.isgate_pass_done ===0 &&(
                      <div
                        onClick={() => {
                          editOpenData(issueDetails);
                        }}
                      >
                        <img
                          src={editIcon}
                          // alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
                          className="accordion-icon "
                          style={{ height: 20, width: 20 }}
                        />
                      </div>
                    )}
                      {issueDetails?.comp_id === issueId ? (
                        <div
                          onClick={() => {
                            onClickSetIssueId("");
                          }}
                        >
                          <img
                            src={MinusIcon}
                            //   alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
                            className="accordion-icon"
                          />
                        </div>
                      ) : (
                        <div
                          onClick={() => {
                            onClickSetIssueId(
                              issueDetails?.comp_id,
                              issueDetails
                            );
                          }}
                        >
                          <img
                            src={plusIcon}
                            // alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
                            className="accordion-icon"
                            style={{ height: 20, width: 20 }}
                          />
                        </div>
                      )}
                    </>
                  </div>
                </div>

                <div>
                  {issueDetails?.comp_id === issueId && (
                    <div>
                      <div className="issue-Details-SubViewTechnician">
                        <div className="details-item">
                          <span className="details-label">Work Shop</span>
                          <span className="details-value">
                            {issueDetails?.WorkShop || "-"}
                          </span>
                        </div>
                        <div className="details-item">
                          <span className="details-label">Estimate Cost</span>
                          <span className="details-value">
                            {issueDetails?.estcost || 0}
                          </span>
                        </div>
                        <div className="details-item">
                          <span className="details-label">Estimate Time</span>
                          <span className="details-value">
                            {issueDetails?.esttime || 0}
                          </span>
                        </div>
                        <div className="details-item">
                          <span className="details-label">Issue Status</span>
                          <span className="details-value">
                            {issueDetails?.issue_status == 1
                              ? "Done"
                              : "Pending"}
                          </span>
                        </div>
                        <div className="details-item">
                          <span className="details-label">Remark</span>
                          <span className="details-value">
                            {issueDetails?.remark || "-"}
                          </span>
                        </div>

                        <div className="details-item">
                          <span className="details-label">Issue</span>
                          <span className="details-value">
                            {issueDetails?.remark || "-"}{" "}
                          </span>
                        </div>

                        <div className="details-item">
                          <span className="details-label">Repair Status</span>
                          <span className="details-value">
                            {issueDetails?.RepairStatus}
                          </span>
                        </div>

                        <div className="details-item">
                          <span className="details-label">Tech Remark</span>
                          <span className="details-value">
                            {issueDetails?.tech_remark || "-"}
                          </span>
                        </div>
                        { jobCardDetails?.isgate_pass_done ===0 &&(
                        <div className="details-item">
                          <button
                            className="addcustomerbutton"
                            onClick={() => OnClickaddPart(issueDetails)}
                          >
                            Add Parts
                          </button>
                        </div>
                        )}
                      </div>
                      <div>
                        {(partlistData || []).map((partDetails) => (
                          <div className="issue-Details-SubViewTechnician">
                            {partDetails?.issue_detail_id ===
                              issueDetails?.comp_id}
                            <div className="details-item">
                              <span className="details-label">Item Name</span>
                              <span className="details-value">
                                {partDetails?.item_name}
                              </span>
                            </div>
                            <div className="details-item">
                              <span className="details-label">Qty.</span>
                              <span className="details-value">
                                {partDetails?.good_qty}
                              </span>
                            </div>
                            { jobCardDetails?.isgate_pass_done ===0 &&(
                            <div
                              onClick={() => {
                                handlePartEdit(partDetails);
                              }}
                            >
                              <img
                                src={editIcon}
                                // alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
                                className="accordion-icon"
                              />
                            </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {addPart && (
        <Modal
          show={addPart}
          onHide={() => setAddPart(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title> Part Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DynamicForm
              formConfig={PartInputs || []}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handlePartFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
            <div className="btncontainer mt-3">
              <button
                onClick={() => {
                  handlePartFormSubmit(formData);
                }}
                className="submit-btn"
              >
                {"Submit"}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}

      <Offcanvas placement={"end"} show={addModel} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {editIssueData?.comp_id ? "Edit Issue" : "Add Issue"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="">
            <AddIssueDynemicForm
              formConfig={IssueInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />

            <div className="col-12 ">
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn w-100"
              >
                {"Submit"}
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default TechnicianDetails;
